<template>
  <div>
    <!--<bread-crumb></bread-crumb>-->
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="상품 정보">
            <div class="column is-multiline" style="overflow-x: auto">
              <div class="column is-full" style="min-width: 1400px">
                <table class="table">
                  <tbody>
                  <tr class="tr-whole-border">
                    <th style="width: 40px;">id</th>
                    <th style="width: 72px;">상품등록일</th>
                    <th style="width: 40px;">노출여부</th>
                    <th style="width: 80px;">카테고리</th>
                    <th style="width: 64px;">파트너명</th>
                    <th style="width: 84px;">이미지</th>
                    <th style="width: 80px;">상품명</th>
                    <th style="width: 100px;">판매가/기준</th>
                    <th style="width: 40px;">조회</th>
                    <th style="width: 40px;">리뷰</th>
                    <th style="width: 40px;">주문신청</th>
                    <th style="width: 40px;">구매완료</th>
                  </tr>

                  <tr class="lp-row many-field-tr" v-if="product.product !== undefined">
                    <td>{{ product.product.id }}</td>
                    <td>{{ product.product.created_time }}</td>
                    <td>
                      <span v-if="product.product.enable_prod">노출</span>
                      <span v-else>비노출</span>
                    </td>
                    <td>
                      <span>{{ category1 }}</span>
                      <span v-if="category2"> > {{ category2 }}</span>
                      <span v-if="category3"> > {{ category3 }}</span>
                    </td>
                    <td style="width:60px">{{ partnerName }}</td>
                    <td style="padding: 6px 12px;">
                      <div :style="'background-image: url('+ product.product.imgs[0] +'); width: 60px; height: 60px; background-size: cover; background-posion: center;'"></div>
                      <!-- <div :style="'background-image: url('+image(product.img)+'); width: 60px; height: 60px; background-size: cover; background-posiproducton: center;'"></div> -->
                    </td>
                    <td>{{ product.product.name }}</td>
                    <td>{{ product.price.price }}</td>
                    <td>{{ product.product.visit }}</td>
                    <td>{{ product.performance.review }}</td>
                    <td>{{ product.product.order_count }}</td>
                  </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-6">
        <div class="box">
          <!-- 작성자 이름 -->
          <admin-box-item title="상품후기 상세">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="제목">
                  <div>{{ value.title }}</div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="작성자">
                  <div>{{ value.author }}</div>
                </admin-form-item>
              </div>


              <div class="column is-full">
                <admin-form-item label="작성일">
                  <div>{{ value.created_time }}</div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="조회수">
                  <div>{{ value.visit }}</div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="평점">
                  <star-rating :rating="value.rate"
                               :star-size="20"
                               :show-rating="false"
                               :read-only="true"></star-rating>
                </admin-form-item>
              </div>

              <div class="column is-full" v-if="value.rates && value.rates.length>0">
                <admin-form-item label="세부 평점">
                  <div class="flex wrap"
                       v-for="(item,idx) in value.rates" :key="'rate-'+idx">
                    <div style="margin-right:8px">{{ item.name }}</div>
                    <star-rating :rating="item.rate"
                                 :star-size="20"
                                 :show-rating="false"
                                 :read-only="true"></star-rating>
                  </div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item>
                  <textarea class="textarea"
                            v-model="value.content"
                            readonly></textarea>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <lp-check-bool @onCheck="check"
                               :checkedVal="value.is_secret"
                               label="비밀글 사용"></lp-check-bool>
              </div>

              <div class="column is-full">
                <admin-form-item label="첨부파일" v-if="value.imgs && value.imgs.length>0">
                  <div class="flex-align">
                    <template v-for="(img,idx) in value.imgs">
                      <a :href="img" target="_blank">
                        <div class="img-attach" v-if="isImage(img)" :style="imgField(img)" :key="'attach-file-'+idx"></div>
                        <div v-else class="img-attach">
                          <i class="material-icons" style="font-size:16px;vertical-align: middle;color:#999">attach_file</i>파일 {{ idx+1 }}
                        </div>
                      </a>
                    </template>
                  </div>
                </admin-form-item>
              </div>

            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-6">
        <div class="box">
          <admin-box-item title="상품후기 댓글 등록">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="작성자" v-if="isAdmin">
                  <div>
                    <lp-adm-drop-input ref="adminput"
                                       :data.sync="userlist"
                                       :selectVal="username"
                                       @onSelect="selectUser"
                                       added_field="type"
                                       :placeholder="username"
                                       width="250px"
                                       listAlign="left"
                                       style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="작성 내용">
                  <textarea class="textarea" v-model="value.comment"></textarea>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
        <!-- 저장하기 -->
        <div class="btn-group-justify-end">
          <div class="button is-danger" @click="deleteComment" v-if="value.comment_date">댓글 삭제</div>
          <button class="button is-primary" @click="clickCommentsReg" v-if="value.comment_date">댓글 수정</button>
          <button class="button is-primary" @click="clickCommentsReg" v-if="!value.comment_date">댓글 등록</button>
        </div>

        <div class="box" v-if="point_setting && point_setting.review_enable">
          <admin-box-item title="적립금 지급">
            <admin-form-item label="적립금액">
              <lp-radio :val.sync="payment.review_payment_type"
                        value_name="value"
                        label_name="label"
                        :data="[{label:'자동 계산',value:true}, {label:'직접 입력', value:false}]"></lp-radio>
              <!-- 직접 입력 -->
              <div v-if="!payment.review_payment_type" style="margin-top:12px">
                <div class="flex-align">
                  <div class="input-title">금액</div>
                  <input class="input"
                         type="number"
                         placeholder="0"
                         v-model="payment.point"
                         @input="e=>setNumber(e)" style="width:100px">
                  <span style="margin-left:8px">원</span>
                </div>
                <div class="flex-align" style="margin-top:8px">
                  <div class="input-title">내용</div>
                  <input class="input payment-content"
                         type="text"
                         placeholder="지급 사유"
                         :value="payment.content"
                         @input="e=>payment.content = e.target.value">
                </div>
              </div>
              <!-- 자동 계산 -->
              <div v-else style="margin-top: 8px">
                <div class="auto-payment-desc">
                  <span @click="routerPush(getPath('point/setting'))"
                        class="unselect"
                        style="text-decoration: underline">적립금/쿠폰 관리 > 적립금 설정</span>에서 설정한 금액을 기준으로 자동 계산 됩니다.</div>
                <div class="flex-align">
                  <div class="input-title">금액</div>
                  <input class="input"
                         type="number"
                         placeholder="0"
                         disabled
                         v-model="value.calc_point" style="width:100px">
                  <span style="margin-left:8px">원</span>
                </div>
              </div>
            </admin-form-item>
            <button class="button is-primary" @click="pointPayment">적립금 지급</button>
          </admin-box-item>
          <admin-box-item title="후기 적립금 지급 내역" v-if="value.save_point && value.save_point.length>0">
            <point-table :list="value.save_point"></point-table>
          </admin-box-item>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import StarRating from "vue-star-rating/src/star-rating";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import LpRadio from "../../module/common/LpRadio";
  import PointTable from "../../module/common/PointTable";
  import moment from 'moment';
  export default {
    layout: 'ProductReviewReg',
    components: {
      PointTable,
      LpRadio,
      LpCheckBool,
      StarRating,
      LpAdmDropInput
    },
    created() {
      this.getUserList();
      this.getPointSetting();
    },
    computed: {
      category1(){
        let category = find(this.catArr1, 'value', this.product.product.category1_id);
        if(category)
          return category.label;
        else
          return '';
      },
      category2(){
        let category = find(this.catArr2, 'value', this.product.product.category2_id);
        if(category)
          return category.label;
        else
          return '';
      },
      category3(){
        let category = find(this.catArr3, 'value', this.product.product.category3_id);
        if(category)
          return category.label;
        else
          return '';
      },
      partnerName(){
        let partner_id;
        if(this.product.product.partner){
          partner_id = this.product.product.partner;
        }

        let partner = find(this.partners, 'value', partner_id);
        if(partner !== undefined)
          return partner.name;
        else
          return '';
      }
    },
    watch: {
      modalStatus(n){
        if(n==='close'){
          let url = this.$store.getters.modalResponse.url;
          if((url).indexOf('comment/delete')>-1){
            this.value.comment = ''
            this.value.comment_date = null;
            this.value.partner = null;
            this.value.admin = null;
            this.value.user_id = null;
            this.value.user_type = null;
          }
          this.getData();
        }
      }
    },
    methods: {
      isImage(img) {
        let result = false;
        ['.jpg', '.jpeg', '.png', '.JPEG', '.JPG', '.PNG', '.gif', '.GIF', '.bmp', '.BMP'].forEach(ext => {
          if(img.indexOf(ext)>-1) {
            result = true;
          }
        });
        return result;
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;margin-right: 12px';
      },
      deleteComment() {
        let value = {
          url: `space/product/review/${this.$route.query.id}/comment/delete`,
          title: '후기를 삭제하시겠습니까?'
        }
        this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
      },
      check(value) {
        this.$axios.post(this.getUrl(`space/product/review/${this.$route.query.id}/secret`), {
          secret: value
        }).then(res=>{
          this.toast('비밀글 사용이 변경되었습니다.');
        })
      },
      // 유저 선택
      selectUser(res) {
        this.value.user_id = res.value;
        this.value.user_type = res.type;
      },
      // 답변 등록
      clickCommentsReg() {
        if(!this.value.comment) {
          this.toast('내용을 작성하세요.');
          return;
        }
        if(this.isAdmin) {
          let param = {
            user_id: this.value.user_id,
            user_type: this.value.user_type,
            comment: this.value.comment
          }
          this.$axios.patch(this.getUrl('space/product/review/'+this.$route.query.id), param
          ).then(res=>{
            if(res.status===200){
              this.toast('완료되었습니다.');
              this.getData();
            }
          })
        }
        else {
          let param = {
            user_id: this.$store.getters.partner.space_partner,
            user_type: 'partner',
            comment: this.value.comment
          }
          this.$axios.patch(this.getUrl('space/product/review/'+this.$route.query.id), param
          ).then(res=>{
            if(res.status===200){
              this.toast('완료되었습니다.');
              this.getData();
            }
          })
        }

      },
      getData(){
        if(this.$route.query.id){
          this.$axios.get(this.getUrl('space/product/review/'+this.$route.query.id))
            .then(res=>{
              this.value = res.data;
              if(res.data.user_type==='admin'){
                this.value.user_id = res.data.admin;
              }
              else if(res.data.user_type==='partner'){
                this.value.user_id = res.data.partner;
              }
              this.getUsername();
              this.initAuthor();

              // 상품 상세 정보 가져오기
              this.$axios.get(this.getUrl('space/product/'+res.data.product_id)).then(res=>{
                this.product = res.data;

                this.getCategory();

                this.$axios.get('admin/partner/simple').then(res => {
                  this.partners = res.data;
                })
              })
            })
        }
      },
      // 작성자 초기 선택
      initAuthor() {
        if(!this.value.user_type) {
          // 작성자 username 초기값 설정
          let user_id ='';
          let type = '';
          if(this.isAdmin) {
            user_id = this.$store.getters.admin.id;
            type = 'admin';
          }
          else {
            user_id = this.$store.getters.partner.id;
            type = 'partner';
          }
          if(user_id) {
            this.userlist.forEach(user=> {
              if(user.value===user_id && user.type===type) {
                this.username = user.name;
                this.value.user_id = this.$store.getters.admin.id;
                if(this.isAdmin) this.value.user_type = 'admin';
                else this.value.user_type = 'partner';
                return;
              }
            })
          }
        }
      },
      getUserList(){
        this.$axios.get('public/user/whole').then(res=>{
          this.userlist = res.data;
          this.getData();
        })
      },
      getUsername(){
        if(this.userlist.length>0){
          for(let i=0; i<this.userlist.length; i++){
            if(this.userlist[i].value===this.value.user_id &&
              this.value.user_type===this.userlist[i].type){
              this.username = this.userlist[i].name;
              break;
            }
          }
        }

      },
      getCategory(){
        // 카테고리 가져오기
        this.$axios.get(this.getUrl('category'))
          .then(res => {

            this.catArr1 = [];
            this.catArr2 = [];
            this.catArr3 = [];

            for (let i = 0; i < res.data.length; i++) {
              let cat = res.data[i];
              // 1차 카테고리 추가
              this.catArr1.push({value: cat.id, label: cat.name});

              for (let j = 0; j < cat.child.length; j++) {
                let cat2 = cat.child[j];
                // 2차 카테고리 추가
                this.catArr2.push({parent: cat.id, value: cat2.id, label: cat2.name});

                for (let k = 0; k < cat2.child.length; k++) {
                  let cat3 = cat2.child[k];
                  // 3차 카테고리 추가
                  this.catArr3.push({parent: cat2.id, value: cat3.id, label: cat3.name});
                }
              }
            }
          });
      },
      setNumber(e) {
        let point = parseInt(e.target.value.substr(0, 5));
        if(point < 0) {
          point = 0;
        }
        this.payment.point = point;
      },
      getPointSetting() {
        this.$axios.get('admin/point/setting').then(res=>{
          this.point_setting = res.data;
        })
      },
      pointPayment() {
        let total_point = 0;
        if(this.payment.review_payment_type) {
          total_point = this.value.calc_point;
        } else {
          total_point = this.payment.point;
        }
        if(total_point === 0) {
          this.toast('적립할 금액이 없습니다');
          return;
        }

        let params = this.payment;
        params.users = [{
          author_id: this.value.author_id,
          reviews: [{
            id: this.value.id,
            calc_point: this.value.calc_point
          }],
          total_point : total_point
        }];
        this.$axios.post('admin/point/payments/review', params).then(res=>{
          if(res.status === 200) {
            // type: this.payment.review_payment_type ? '후기 적립금' : '수동 지급',
            this.value.save_point.splice(0,0, {
              type: '후기 적립금',
              content: this.payment.review_payment_type ? '상품 후기 적립금 지급' : this.payment.content === '' ? '적립금 수동 지급' : this.payment.content,
              point: total_point,
              created_time: moment().format('YYYY-MM-DD'),
              manager: '관리자'
            });
            this.toast('적립금이 지급되었습니다');
            this.payment = {
              review_payment_type: false,
              content: '',
              point: 0,
              duplicate: false,
              hasMany: false
            };
          }
        });
      }
    },
    data () {
      return {
        id: 0,
        // 문의 내용
        value: {
          id: 3,
          product: "" ,
          author: "",
          created_time: "",
          title: null,
          content: "",
          is_secret: false,
          rate: 4,
          rates:[],
          user_id:'',
          user_type:''
        },
        product: {},
        partners : [],
        // 작성자 전체 목록 리스트
        userlist: [],
        username: '',
        // 카테고리
        catArr1: [],
        catArr2: [],
        catArr3: [],
        payment: {
          review_payment_type: false,
          content: '',
          point: 0,
          duplicate: false,
          hasMany: false
        },
        point_setting: undefined
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'

  .comment-sub-title
    background #ddd
    color #333
    padding 8px 16px
    font-size 0.95rem
    border-radius 3px
    display flex
    justify-content space-between

  .ask-content
    width 260px
    padding 6px 10px
    font-size .85rem
    color #555
    border-radius 3px
    display inline-block
    border 1px solid #ddd

  .lp-img-bg
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    background-color rgba(0,0,0,0.5)
    z-index 100

  .lp-img-full
    position fixed
    top 50%
    left 50%
    transform translate(-50%, -50%)
    max-height 80vh

  .input-title
    width 40px
  .payment-content
    width 124px

  .auto-payment-desc
    color #9A9A9A
    font-size 12px
    margin-bottom 8px
</style>
